export type ServiceType = string

export const SERVICE_TYPE_DELIVERY = "DELIVERY"
export const SERVICE_TYPE_PICKUP = "PICKUP"

export const SERVICE_TYPE_DELIVERY_BY_CLIENT = "DELIVERYBYCLIENT"

export const isPickup = (value: ServiceType | undefined | null): boolean => {
    if (!value) return false
    const v = String(value).toUpperCase()
    return v === SERVICE_TYPE_PICKUP || v === SERVICE_TYPE_DELIVERY_BY_CLIENT || v === "TAKEOUT"
}

export const isDeliveryByClient = (value: ServiceType | undefined | null): boolean => {
    if (!value) return false
    return String(value).toUpperCase() === SERVICE_TYPE_DELIVERY_BY_CLIENT
}

export interface OrderTypeDTO {
    id: ServiceType
    name: string
}
